export function appPath(path: `/${string}`): string {
  return window.location.pathname.startsWith('/app-v2') ? `/app-v2${path}` : path;
}
